import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { APP_ENVIRONMENT, AppEnvironment } from './app/app.environment';
import { AppModule } from './app/app.module';

fetch('/configs/environment.json')
  .then(response => response.json())
  .then(environment => start(environment))
  .catch(reason => console.error(reason));

function start(environment: AppEnvironment) {

  const extraProviders = [
    {
      provide: APP_ENVIRONMENT,
      useValue: environment,
    }
  ];

  platformBrowserDynamic(extraProviders)
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
}